export const isSavingCareMediation = (state) => state.isSavingCareMediation;
